import HttpRequest from './http_request'

class projectProvider extends HttpRequest{
    initData(path) {
        return this.fetch(path)
    }
    CustomData(type, url, data) {
        return this.request(type, url, data)
    }
}

export default projectProvider